import {Component, Optional, SkipSelf} from "@angular/core";

import {
    CustomerBillingAccountDunningAssignPaymentsComponent
} from "../../customer-billing-account-dunning-assign-payments.component";
import {QlService} from "../../../../../../../core/shared/ql/service/ql.service";
import {QlMockService} from "../../../../../../../core/shared/ql/mock/ql-mock.service";
import * as testA from "../data/mock-testA.json"

@Component({
    selector: 'customer-billing-account-dunning-assign-payments-test-component',
    templateUrl: '../../customer-billing-account-dunning-assign-payments.component.html',
    styleUrls: ['../../customer-billing-account-dunning-assign-payments.component.scss'],
    standalone: false,
    providers: [
        {
            provide: QlService,
            useFactory: () => new QlMockService(testA),
            deps: [[new SkipSelf(), new Optional(), QlService]]
        }
    ]
})
export class CustomerBillingAccountDunningAssignPaymentsTestComponent
    extends CustomerBillingAccountDunningAssignPaymentsComponent {


}